type Props = {
  height: number;
  className?: string;
};

export function Loading({ height = 16, className }: Props) {
  return (
    <div
      style={{ height: height }}
      className={`w-full overflow-hidden ${className}`}
    >
      <div style={{ height: height }} className="relative m-auto h-16 w-full">
        <div className="loader-items m-auto flex max-w-max gap-2">
          <div
            style={{ height: height, width: height }}
            className="bg-blue-alt-900 rounded-full"
          ></div>
          <div
            style={{ height: height, width: height * 2.5 }}
            className="rounded-full bg-green-400"
          ></div>
          <div
            style={{ height: height, width: height }}
            className="rounded-full bg-green-200"
          ></div>
          <div
            style={{ height: height, width: height }}
            className="rounded-full bg-green-400"
          ></div>
        </div>
        <div className="loader-items m-auto flex max-w-max gap-2">
          <div
            style={{ height: height, width: height }}
            className="rounded-full bg-green-400"
          ></div>
          <div
            style={{ height: height, width: height * 2.5 }}
            className="rounded-full bg-green-200"
          ></div>
        </div>
        <div className="loader-items m-auto flex max-w-max gap-2">
          <div
            style={{ height: height, width: height }}
            className="rounded-full bg-green-400"
          ></div>
          <div
            style={{ height: height, width: height }}
            className="rounded-full bg-green-200"
          ></div>
          <div
            style={{ height: height, width: height }}
            className="bg-blue-alt-900 rounded-full"
          ></div>
        </div>
        <div className="loader-items m-auto flex max-w-max gap-2">
          <div
            style={{ height: height, width: height * 2.5 }}
            className="rounded-full bg-green-400"
          ></div>
        </div>
        <div className="loader-items m-auto flex max-w-max gap-2">
          <div
            style={{ height: height, width: height }}
            className="bg-blue-alt-900 rounded-full"
          ></div>
        </div>
        <div className="loader-items m-auto flex max-w-max gap-2">
          <div
            style={{ height: height, width: height }}
            className="rounded-full bg-green-200"
          ></div>
          <div
            style={{ height: height, width: height * 2.5 }}
            className="rounded-full bg-green-400"
          ></div>
          <div
            style={{ height: height, width: height }}
            className="bg-blue-alt-900 rounded-full"
          ></div>
        </div>
      </div>
    </div>
  );
}
